import { classNames } from '../../../../utils/style-class.utils';
export var tabInactive = function (isOnlyTab) {
    return "border-transparent hover:text-uiLight hover:border-uiLight whitespace-nowrap p-4 text-".concat(isOnlyTab ? 'start' : 'center', " border-b-4 items-").concat(isOnlyTab ? 'start' : 'center');
};
export var tabActive = function (isOnlyTab, colour) {
    return "border-".concat(colour, " whitespace-nowrap p-4 border-b-4 items-").concat(isOnlyTab ? 'start' : 'center', " text-").concat(isOnlyTab ? 'start' : 'center');
};
export var getTabClass = function (activeTab, className, isOnlyTab, activeTabColour, activeTabClassName) {
    if (isOnlyTab === void 0) { isOnlyTab = false; }
    if (activeTabColour === void 0) { activeTabColour = 'quatenary'; }
    var tabClassName = isOnlyTab ? 'pl-4 ' : ' ';
    tabClassName += activeTab
        ? tabActive(isOnlyTab, activeTabColour)
        : tabInactive(isOnlyTab);
    if (className !== '') {
        tabClassName = classNames(tabClassName, className);
    }
    if (isOnlyTab) {
        tabClassName = tabClassName
            .replace('border-primary', '')
            .replace('border-b-4', '');
    }
    return activeTab && activeTabClassName ? activeTabClassName : tabClassName;
};
//# sourceMappingURL=tab.styles.js.map